import { handleResponse, handleError, axiosPaymentLinkInstance } from './index';

// this API is the pharmarx one (which should be renamed to payment link API as that is what it actually is)

export function cancelTransaction(transactionId) {
  return axiosPaymentLinkInstance
    .post('/cancel', {
      transactionId,
    })
    .then(handleResponse)
    .catch(handleError);
}
